import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';
import { apiClient } from '../../lib/axios';

const VisitorCounter: React.FC = () => {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const response = await apiClient.get('/api/visitor-count');
        if (response.data && typeof response.data.count === 'number') {
          setCount(response.data.count);
        }
      } catch (error) {
        console.debug('Failed to fetch visitor count');
      }
    };

    fetchCount();
    // Refresh every 30 seconds
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, []);

  if (count === null) return null;

  return (
    <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 text-sm whitespace-nowrap">
      <Users className="h-4 w-4 mr-2 text-green-400" aria-hidden="true" />
      <span className="font-medium">
        {count.toLocaleString()} <span className="text-white/70">Visitors</span>
      </span>
    </div>
  );
};

export default VisitorCounter;
